import {
  AmountCellViewModel,
  BenefitCellViewModel,
  DateCellViewModel,
  EmployeeNameCellViewModel,
  NoteCellViewModel,
  StatusCellViewModel,
  UpdatedAtCellViewModel
} from './cells';
import { OverlayViewModel } from '../../../hooks/useOverlay';
import { TFunction } from 'i18next';
import { MutableRefObject } from 'react';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { NavigateFunction } from 'react-router';
import { TableViewModel } from '../../../lib/components/compound/table/viewModels/table';
import { ReceiptsRowViewModel } from './row/viewModel';
import { ReceiptsViewModel } from '../../../viewModels/receipts';
import { ProviderContext } from 'notistack';
import { ActionsCellViewModel } from './cells/actions/viewModel';
import {
  ReceiptAction,
  ReceiptActionDialogConfirmDetails,
  ReceiptActionDialogViewModel
} from '../dialogs/action/viewModel';
import ReceiptStore from '../../../stores/receipts/details';

export class ReceiptsTableViewModel extends TableViewModel<
  ReceiptsViewModel,
  ReceiptsRowViewModel
> {
  public noteOverlay = new OverlayViewModel<ReceiptsViewModel>();
  public actionDialog: ReceiptActionDialogViewModel;

  private handleConfirm: Record<
    ReceiptAction,
    (receiptIds: string[], note?: string) => Promise<void>
  > = {
    delete: (ids) => this.receiptStore.deleteList(ids),
    approve: (ids) => this.receiptStore.approveList(ids),
    reject: (ids, note) => this.receiptStore.rejectList(ids, note),
    settle: (ids) => this.receiptStore.settleList(ids)
  };

  constructor(
    public navigate: NavigateFunction,
    public translate: TFunction,
    public snackbar: ProviderContext,
    protected receiptStore: ReceiptStore,
    apiRef: MutableRefObject<GridApiPro>
  ) {
    super(apiRef);
    this.actionDialog = new ReceiptActionDialogViewModel(translate);
    this.actionDialog.onConfirm.subscribe(async (items, context) => {
      context = context as ReceiptActionDialogConfirmDetails;
      if (!items || !context.action) return;
      await this.handleConfirm[context.action](
        items.map((r) => r.id),
        context.note
      );
    });
  }

  createRow(entity: ReceiptsViewModel): ReceiptsRowViewModel {
    return new ReceiptsRowViewModel(entity, this);
  }

  public async fetchColDefData() {}

  protected _buildColDef() {
    return [
      BenefitCellViewModel.buildColDef(this.translate),
      EmployeeNameCellViewModel.buildColDef(this.translate),
      AmountCellViewModel.buildColDef(this.translate),
      DateCellViewModel.buildColDef(this.translate),
      UpdatedAtCellViewModel.buildColDef(this.translate),
      NoteCellViewModel.buildColDef(this.translate),
      StatusCellViewModel.buildColDef(this.translate),
      ActionsCellViewModel.buildColDef(this.translate)
    ];
  }
}

export class EmployeeReceiptsTableViewModel extends ReceiptsTableViewModel {
  protected _buildColDef() {
    return [
      BenefitCellViewModel.buildColDef(this.translate),
      AmountCellViewModel.buildColDef(this.translate),
      DateCellViewModel.buildColDef(this.translate),
      UpdatedAtCellViewModel.buildColDef(this.translate),
      NoteCellViewModel.buildColDef(this.translate),
      StatusCellViewModel.buildColDef(this.translate),
      ActionsCellViewModel.buildColDef(this.translate)
    ];
  }
  constructor(
    public navigate: NavigateFunction,
    public translate: TFunction,
    public snackbar: ProviderContext,
    receiptStore: ReceiptStore,
    apiRef: MutableRefObject<GridApiPro>
  ) {
    super(navigate, translate, snackbar, receiptStore, apiRef);
  }
}
